import 'stylesheets/front/product.scss';
import 'stylesheets/front/new_category.scss';